import { displayWalletAddress } from "@/utils/wallet";
import Copy from "@/ui/copy";
import { IconComponent, IconsTypes } from "./icon";

const WalletAddress = ({
  address,
  chainIcon,
  withIcon = true,
  withCopy = false,
  fullAddress = false,
}: {
  address: string;
  chainIcon?: IconsTypes;
  withIcon?: boolean;
  withCopy?: boolean;
  fullAddress?: boolean;
}) => {
  return (
    <div className="font-semibold text-xs inline-flex gap-[0.3125rem] items-center text-white">
      {withIcon && chainIcon && (
        <IconComponent
          name={chainIcon}
          className="w-[0.7500rem] h-[0.7500rem]"
        />
      )}
      <div className="flex items-baseline">
        {fullAddress ? address : displayWalletAddress(address)}{" "}
        {withCopy && <Copy value={address} />}
      </div>
    </div>
  );
};

export default WalletAddress;
